import type { FC, ReactNode } from 'react'

import { Plus } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SuggestionChipsProps {
    items: string[]
    onPick: (item: string) => void
    label?: string
    className?: string
}

const SuggestionChips: FC<SuggestionChipsProps> = ({ items, onPick, label = 'Quick add', className }): ReactNode => {
    if (items.length === 0) return null

    return (
        <div className={cn('flex flex-wrap items-center gap-1.5', className)}>
            <span className='mr-0.5 text-xs text-muted-foreground'>
                {label}:
            </span>

            {items.map(item => (
                <button
                    key={item}
                    type='button'
                    onClick={() => onPick(item)}
                    className='inline-flex h-7 items-center gap-1 rounded-md border border-dashed border-border bg-background px-2 text-xs font-medium text-muted-foreground transition-colors outline-none hover:border-primary/50 hover:text-primary focus-visible:ring-3 focus-visible:ring-ring/40'
                >
                    <Plus className='size-3' />
                    {item}
                </button>
            ))}
        </div>
    )
}

export default SuggestionChips
